// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import Table from "../../../../components/Table";

// MARK: Stores
import OfferStore from "../../../../stores/OfferStore";

// MARK: Resources
import strings from "../../../../resources/strings";

interface IProps {
	offerStore: OfferStore;
}

@inject("offerStore")
@observer
export default class OffersTable extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.offerStore.getOffers();
	}

	public render() {
		const { offerStore } = this.props;
		return (
			<>
				<Table
					title={strings.offers.title}
					rows={offerStore.offersTableRows}
					header={offerStore.header}
					pageOffset={offerStore.pageOffSet}
					loading={offerStore.loading}
					tableIsEmptyMessage={strings.offers.table.tableIsEmpty}
					prevPage={offerStore.previousPage}
					nextPage={offerStore.nextPage}
					onAddClick={() => offerStore.startOfferCreateOrEdit()}
					onEditClick={(offerId) => offerStore.startOfferCreateOrEdit(offerId)}
					onDeleteClick={(offerId, offerName) => offerStore.openDeleteOfferDialog(offerId, offerName)}
				/>
			</>
		);
	}
}
